import { DateTime } from 'luxon';

export default class DateUtils {
  /**
   * Checking if given date object is valid
   * @param {Date} date
   */
  static isValidDate(date) {
    return date instanceof Date && date.toString() !== 'Invalid Date';
  }

  static isValidDateFormat(dateString, dateFormat = 'yyyy/M/d h:mm a', timeZone = 'local') {
    return DateTime.fromFormat(dateString, dateFormat, {
      zone: timeZone,
    }).isValid;
  }
}
